import { NextHealthScreenProps } from '../types';

const useViewModel = (props: NextHealthScreenProps): NextHealthScreenProps => props;

export { useViewModel };
